function isMobile() {
  if ($('body').width() <= 1199) {
    return true;
  }
  return false;
}
function isSmallDevice() {
  if ($('body').width() <= 1199 && $('body').width() >= 768) {
    return true;
  }
  return false;
}

export default () => {
  $('.new-layout-header__link').on('click', function (e) {
    if (isMobile() && !$(this).hasClass('disable-slide')) {
      slideOutSubMenu(e, $(this));
    }
  });

  $('.new-layout-header__actions-hamburger').on('click', function () {
    openSlider($(this));

    if (isSmallDevice()) {
      $('.new-layout-header__actions-hamburger-close').removeClass('hide');
      $(this).addClass('hide');
    }
  });

  $(
    '.new-layout-header__mobile-close, .new-layout-header__actions-hamburger-close'
  ).on('click', function () {
    closeSlider($(this));

    if (isSmallDevice()) {
      $('.new-layout-header__actions-hamburger').removeClass('hide');
      $(this).addClass('hide');
    }
  });

  $('.new-layout-header--mobile .title__link').on('click', function (e) {
    slideInSubMenu(e, $(this));
  });

  $('.new-layout-header--mobile .title__back-link').on('click', function (e) {
    slideOutSubMenu(e, $(this));
  });

  $('.new-layout-header__underlay').on('click', function () {
    closeSlider($(this));
    if (isSmallDevice()) {
      $('.new-layout-header__actions-hamburger').removeClass('hide');
      $('.new-layout-header__actions-hamburger-close').addClass('hide');
    }
  });

  // Mobile Menu Functions
  function openSlider($this) {
    $('body').addClass('scroll-locked');
    $this.parents('.new-layout-header').addClass('new-layout-header--open');
    $this
      .parents('.new-layout-header')
      .find('.new-layout-header__nav')
      .first()
      .addClass('new-layout-header__nav--open');
  }
  function closeSlider($this) {
    $('body').removeClass('scroll-locked');
    $('.dropdown').removeClass('active-menu');
    $('.megamenu__column').removeClass('megamenu__column--open-child');
    $('.new-layout-header__nav').removeClass('new-layout-header__nav--open');
    $('.new-layout-header__items').removeClass(
      'new-layout-header__items--open-child'
    );
    $('.new-layout-header--mobile').removeClass('new-layout-header--open');
    // $this.parents('.new-layout-header').find('.new-layout-header__nav').removeClass('new-layout-header__nav--open')
    $('.new-layout-header__nav').removeClass('new-layout-header__nav--open');
  }
  function slideInSubMenu(e, $this) {
    e.preventDefault();
    $('.megamenu__column')
      .not($this.parents('.megamenu__column'))
      .removeClass('megamenu__column--open-child');
    $this
      .parents('.megamenu__column')
      .toggleClass('megamenu__column--open-child');
  }
  function slideOutSubMenu(e, $this) {
    e.preventDefault();
    $this.parents('.dropdown').toggleClass('active-menu');
    $this
      .parents('.new-layout-header__items')
      .toggleClass('new-layout-header__items--open-child');
  }
};
